export enum OrganizationRoleDrawerTabEnum {
  CREATE = 'create',
  UPDATE = 'update',
}
